module.exports = __webpack_public_path__ + "static/img/submit-success.432a9fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/submit-success.png
// module id = nla4
// module chunks = 167